import React from 'react'
import { View, ViewStyle, StyleSheet, TextStyle } from 'react-native'
import { color, spacing, fontSize, fontFamily, fontWeight } from '@partipost-cm-new/app-preview/dist/Styles/Base'
import Card from '@partipost-cm-new/app-preview/dist/Components/Card'
import PartiText from '@partipost-cm-new/app-preview/dist/Components/PartiText'
import { useNewTranslation } from 'hooks'
import Icon from 'particles/Icon'
import { moderateScale } from '@partipost-cm-new/app-preview/dist/Utils/Scaling'

interface MediaSubmitBlockProps {
    title: string
    maxPhotos: number
    cardStyle?: ViewStyle
    titleStyle?: TextStyle
}

const MediaSubmitBlock: React.FC<MediaSubmitBlockProps> = ({ title, cardStyle, maxPhotos, titleStyle }) => {
    const [t] = useNewTranslation()

    return (
        <Card cardStyle={{ ...styles.cardContainer, ...cardStyle }}>
            <View style={styles.titleContainer}>
                <PartiText style={{ ...styles.title, ...titleStyle }}>{title}</PartiText>
            </View>
            <View style={styles.container}>
                <Icon size="36px" name="image" color="neutralAction" form="fill" />
                <PartiText style={styles.text}>
                    {t('placeholderText.uploadMaximumPhotosVideos', { limit: maxPhotos })}
                </PartiText>
            </View>
        </Card>
    )
}

const styles = StyleSheet.create({
    cardContainer: {
        borderRadius: moderateScale(10),
        padding: spacing.medium,
        marginBottom: moderateScale(24),
    },
    titleContainer: {
        paddingBottom: spacing.small,
        flexDirection: 'row',
    },
    title: {
        fontSize: fontSize.medium,
        fontFamily: fontFamily.title,
        fontWeight: fontWeight.bold,
        color: color.doveGray,
    },
    container: {
        justifyContent: 'center',
        alignItems: 'center',
        padding: spacing.small,
    },
    text: {
        paddingTop: spacing.small,
        textAlign: 'center',
        width: '70%',
        color: color.doveGray,
    },
})

export default MediaSubmitBlock
